import { render, staticRenderFns } from "./ItemAttachments.vue?vue&type=template&id=67da644a&"
import script from "./ItemAttachments.vue?vue&type=script&lang=js&"
export * from "./ItemAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports